import { useLayoutEffect } from "react";
import { useLocation, useSearch } from "wouter";

import { WORK_QUEUE_PATH } from "../../paths";
import {
  CATEGORY_PARAM,
  isWorkKind,
  isWorkStatus,
  STATUS_PARAM,
} from "../constants";
import { useWorkQueueSession } from "../WorkQueueProvider";

// A link that promises a category must not open on a saved Resolved filter or search.
export const useCategoryLink = () => {
  const search = useSearch();
  const [, navigate] = useLocation();
  const { changeFilters } = useWorkQueueSession();

  useLayoutEffect(() => {
    const params = new URLSearchParams(search);
    const category = params.get(CATEGORY_PARAM);
    const status = params.get(STATUS_PARAM);
    if (!isWorkKind(category)) {
      return;
    }
    changeFilters({
      category,
      status: isWorkStatus(status) ? status : "pending",
      query: "",
      selectedKey: null,
    });
    navigate(WORK_QUEUE_PATH, { replace: true });
  }, [search, navigate, changeFilters]);
};
